import { getNamedModelHistoryRequest } from 'api/Exec/api';
import { NamedModelHistory } from 'api/Exec/types';
import getErrorFromPromiseReason from 'app/helpers/getErrorFromPromiseReason';

import { message } from 'antd';
import { useCallback, useEffect, useState } from 'react';

const useNamedModelHistory = (namedModelId: string | undefined) => {
  const [ isLoading, setIsLoading ] = useState<boolean>(true);
  const [ namedModelHistory, setNamedModelHistory ] = useState<NamedModelHistory[]>([]);

  const fetchNamedModelHistory = useCallback((abortController?: AbortController) => {
    setIsLoading(true);
    if (!namedModelId) {
      return;
    }
    getNamedModelHistoryRequest(namedModelId, abortController)
      .then((response) => {
        setNamedModelHistory(response.data);
      })
      .catch((reason) => {
        if (!abortController?.signal.aborted) {
          message.error(getErrorFromPromiseReason(reason));
        }
      })
      .finally(() => {
        if (!abortController?.signal.aborted) {
          setIsLoading(false);
        }
      });
  }, [ namedModelId ]);

  useEffect(() => {
    const abortController = new AbortController();
    fetchNamedModelHistory(abortController);

    return () => {
      abortController.abort();
    };
  }, [ fetchNamedModelHistory ]);

  return { fetchNamedModelHistory, namedModelHistory, isLoading };
};

export default useNamedModelHistory;
